import React from 'react';
import {BrowserRouter} from "react-router-dom"
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './components/App';
import { RootStoreContext } from './contexts/rootStoreContext';
import RootStore from './store/rootStore';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RootStoreContext.Provider value={new RootStore()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
  </RootStoreContext.Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
